// 音频组件
<template>
    <div class="audioAssembly" v-if="staticeData">
        <audio
        ref="music"
        id="music"
        :loop="staticeData.option.musicOption.loop"
        :autoplay="staticeData.option.musicOption.autoplay"
        :src="staticeData.option.musicOption.src"></audio>
        <audio
        ref="sound"
        id="sound"
        :loop="soundOption.loop"
        :autoplay="soundOption.autoplay"
        :src="soundOption.src"
        ></audio>
        <!-- http://hmltec.oss-cn-beijing.aliyuncs.com/wuchang/vtours/media/backgroundmusic.mp3 -->
    </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
let audioState = createNamespacedHelpers("audioState");
let publicData = createNamespacedHelpers("publicData");
export default {
    data() { 
        return {
            currentSoundOption: {
                loop: true,
                autoplay: true,
                src: "",
            },
            src: "",
        }
    },
    computed: {
        ...audioState.mapState(["musicOption","soundOption","auidoStateArr"]),
        ...publicData.mapState(["staticeData","firstLevelIndex","secondLevelIndex","levelThreeIndex","allData"])
        
    },
    beforeDestroy(){
        this.setSoundSrc("");
    },
    methods: {
        ...audioState.mapMutations(["setSoundSrc"]),
        setAudioState(audio,flag){
            console.log(flag);
            if(!flag){
                audio.pause();
            }else{
                setTimeout(() => {
                    audio.play();
                },500)
            }
            
            
            
        },
    },
    watch: {
        staticStateData(nv,ov){
        },
        auidoStateArr(nv,ov){
            console.log(nv);
            setTimeout(() => {
                if(nv[0]){
                    this.setAudioState(this.$refs.music,true);
                }else if(!nv[0]){
                    this.setAudioState(this.$refs.music,false);
                }
            },50);
            
            setTimeout(() => {
                if(nv[1]){
                    let vtour = this.allData[this.firstLevelIndex].dataArr[this.secondLevelIndex].list[this.levelThreeIndex].vtour;
                    this.setSoundSrc("https://hmltec.oss-cn-beijing.aliyuncs.com/jingshan/staticState/audio/"+ vtour +".mp3");
                    this.setAudioState(this.$refs.sound,true);
                }else if(!nv[1]){
                    this.setAudioState(this.$refs.sound,false);
                }
            },20)
            
        },
        soundPlayState(nv,ov){
            if(nv){
                Math.floor(Math.random() * 2)?this.setSoundSrc("https://hmltec.oss-cn-beijing.aliyuncs.com/chongyang/media/0201.mp3"):this.setSoundSrc("https://hmltec.oss-cn-beijing.aliyuncs.com/chongyang/media/0202.mp3");
            }
            this.setAudioState(this.$refs.sound,nv);
        }
    }
}
</script>

<style lang="scss" scoped>
</style>